import LecomLabel from '../../label/label.jsx';

const Realize = {
	InputAutocompleteSelect: window.InputAutocompleteSelect
};

export default class InputAutocompleteSelect extends Realize.InputAutocompleteSelect {

	render() {

		var optionSelected = this.renderSelectedOptions();		
	
		return (
			<div>
				{this.renderLecomLabel()}
				<div className={this.className()}>
					<span className={"caret " + this.autocompleteDisabled()} onClick={this.focusSelect}>{this.autocompleteReadOnly()}</span>
						<InputText
							className={this.readOnlyClassAutocomplete()}
							id={this.selectId()}
							value={this.renderSelectedOptions() || this.props.defaultValue}
							disabled={this.props.disabled}
							readOnly={this.props.readOnly}
							placeholder={this.props.placeholder}
							onFocus={this.props.onFocus}
							errors={this.props.errors}
							ref="select"
							key={"autocomplete_select_" + this.generateUUID()}
							title={optionSelected}
							readOnly={this.props.readOnly}
							onClick={this.props.onClick}
						/>
				</div>
				{this.renderLecomLabel()}
			</div>
		);
	}

	autocompleteReadOnly(){
		const readOnly = this.props.readOnly;
		const disabled = this.props.disabled

		if(readOnly === true || disabled === true){
			return ''
		} else {
			return '▼'
		}
	}

	autocompleteDisabled(){
		const disabled = this.props.disabled;
		const readOnly = this.props.readOnly;

		if(disabled === true){
			return 'disabled'
		} else if(readOnly === true) {
			return 'readonly'
		} else {
			return ''
		}
	}

	readOnlyClassAutocomplete() {
		const readOnly = this.props.readOnly;

		if(readOnly === true){
			return 'readonly-autocomplete';
		} else {
			return ''
		}
	}

	renderLecomLabel() {
		return (
			<LecomLabel
			{...this.propsWithoutCSS()}
			id={this.props.id} active={this.labelIsActive()}
			key={`lecom--label__${this.props.id}`}
			/>
		);
	}

	labelIsActive() {
		let inputValue = this.state.value;

		return (inputValue != null && String(inputValue).length > 0);
	}
}
